// src/components/CreateScan/styled.ts
import styled from 'styled-components';
import {
  panel,
  panelHeader,
  panelTitle,
  primaryButton,
  secondaryButton,
} from 'components/explore/consoleStyled';

export const ScanContainer = styled.div`
  ${panel}
  margin: 12px 0 0;
`;

export const ScanHeaderRow = styled.div`
  ${panelHeader}
`;

export const ScanLabel = styled.div`
  ${panelTitle}
`;

export const ScanButton = styled.button`
  ${primaryButton}

  &[data-status='completed'] {
    background: var(--good);
    border-color: var(--good);
  }
  &[data-status='processing'] {
    background: var(--warn);
    border-color: var(--warn);
  }
  &[data-status='failed'] {
    background: var(--bad);
    border-color: var(--bad);
  }
`;

export const ProductDropdown = styled.select`
  height: 32px;
  flex: 1;
  min-width: 0;
  padding: 0 10px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: 6px;
  color: var(--ink);
  font: inherit;
  font-size: 13px;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; /* push them to ends */
  width: 100%; /* take full width of parent */
  gap: 10px;
`;

export const DisabledMessage = styled.div`
  padding: 10px;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: 6px;
  color: var(--ink-3);
  font-size: 12.5px;
  text-align: center;
  margin-top: 10px;
`;

export const ViewReportButton = styled.button`
  ${secondaryButton}
  border-color: var(--good);
  color: var(--good);
`;
